import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";
import { RoleMaster } from "../models/rolemaster";

@Injectable({
  providedIn: 'root'
})
export class RoleMasterService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'role/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  )
   {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }
  getAllRoles(): Observable<Array<RoleMaster>> {
    return this.httpService.get(this.apiEndpoint + 'getAllRoles').pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewRole(LevelID?: number): Observable<Array<RoleMaster>> {
    return this.httpService.get(this.apiEndpoint + 'viewRole/' + (LevelID ? LevelID : '')).pipe(map((result: any) => {
      if (result.Success) {

        return result.Data;
      } else {
        return [];
      }
    }));

  }
  saveRole(level1: RoleMaster): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'saveRole/', level1).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  deleteRole(LevelID?: number): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteRole/' + (LevelID ? LevelID : ''), LevelID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(Level_Name?: string,Level_Id?: number): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?RoleName=' + (Level_Name ? Level_Name : '')+ '&RoleId=' + (Level_Id ? Level_Id : 0)).pipe(map((result: any) => {
        return result;
    }));
  }
}


